import {createGlobalState, useGlobalState} from 'react-use';

export const useGlobalLoading = createGlobalState(false);